<div class="ceg-selector-container">
    <h1>Válasszon céget</h1>
    <p class="subtitle">Kérjük, válassza ki a céget, amellyel dolgozni szeretne.</p>

    @if (loading) {
        <div class="loading-container">
            <mat-spinner diameter="48"></mat-spinner>
            <p>Cégek betöltése...</p>
        </div>
    } @else if (error) {
        <div class="error-container">
            <mat-icon>error</mat-icon>
            <p>{{ error }}</p>
            <button mat-flat-button color="primary" (click)="loadCegek()">
                Újra próbálom
            </button>
        </div>
    } @else {
        <div class="ceg-list">
            @for (ceg of cegek; track ceg.uniqueId) {
                <mat-card class="ceg-card" (click)="selectCeg(ceg)">
                    <mat-card-content>
                        <mat-icon>business</mat-icon>
                        <span class="ceg-name">{{ ceg.cegNev }}</span>
                    </mat-card-content>
                </mat-card>
            }
        </div>
    }
</div>
